import Equipment from 'ui/Element/Field/Autocomplete/Option/Equipment'
import Request from 'ui/Element/Field/Autocomplete/Option/Request'
import Organisation from 'ui/Element/Field/Autocomplete/Option/Organisation'
import ServiceItem from 'ui/Element/Field/Autocomplete/Option/ServiceItem'
import Person from 'ui/Element/Field/Autocomplete/Option/Person'
import Article from 'ui/Element/Field/Autocomplete/Option/Article'
import DocChunk from 'ui/Element/Field/Autocomplete/Option/DocChunk'
import Documentation from 'ui/Element/Field/Autocomplete/Option/Documentation'

/**
 * Will load the appropriate option component based on the `type` of the incoming
 * option.
 *
 * @param {Object} props    props for the option
 *
 * @returns {*}
 */
const Multi = (props) => {
  const { metatype = null, value: { docType = null } = {} } = props.option || {}
  const type = metatype || docType

  const optionProps = { isMulti: true, ...props }

  return (
    <>
      {type === 'article' && (<Article {...optionProps} />)}
      {type === 'docChunk' && (<DocChunk {...optionProps} />)}
      {type === 'documentation' && (<Documentation {...optionProps} />)}

      {type === 'serviceitem' && (<ServiceItem {...optionProps} />)}
      {type === 'request' && (<Request {...optionProps} />)}
      {type === 'equipment' && (<Equipment {...optionProps} />)}
      {type === 'organisation' && (<Organisation {...optionProps} />)}
      {type === 'person' && (<Person {...props} />)}
    </>
  )
}

export default Multi
